import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import image from "../../assets/images/dummy_pic.jpeg"; // Default image
import { BaseURL, uniqueToken } from "../../api/DataApis";
import './User.css'; // Custom styles

const View = () => {
  document.title = "Vendor | View";
  const [Users, setUsers] = useState({});
  const [loading, setLoading] = useState(true); // State to manage loader
  const params = useParams();
  const UserID = params.uid;

  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/user/view/${UserID}`;

    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setUsers(res.data.data[0]);
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false); // Stop loader when data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container my-5">
      <div className="card shadow-lg p-4">
        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {/* Page Title */}
            <h1 className="page-title text-center mb-4">Vendor's Details</h1>

            {/* Profile Image and Basic Info */}
            <div className="profile-header text-center">
              <img
                className="profile-image rounded-circle mb-4"
                src={Users?.profile_image ? Users?.profile_image : image}
                alt="Profile"
                style={{ width: '150px', height: '150px', objectFit: 'cover', border: '3px solid #ddd' }}
              />
              <h5 className="user-name mb-1">{Users?.name}</h5>
              <p className="user-role">Class:&nbsp; <b>{Users?.userType}</b></p>
            </div>

            {/* Personal Information Section */}
            <div className="profile-info mt-4">
              <h3 className="section-title">Personal Information</h3>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <p><strong>Email: &nbsp;</strong>{Users?.email}</p>
                  <p><strong>Phone: &nbsp;</strong>{Users?.mobile}</p>
                  <p><strong>Address:&nbsp; </strong>{Users?.address}</p>
                  <p><strong>Vehicle Number: &nbsp;</strong>{Users?.vehicle_number}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <p><strong>Country: &nbsp;</strong>{Users?.countryId?.[0]?.name}</p>
                  <p><strong>State: &nbsp;</strong>{Users?.stateId?.[0]?.name}</p>
                  <p><strong>City: &nbsp;</strong>{Users?.cityId?.[0]?.name}</p>
                  <p><strong>Station Name: &nbsp;</strong>{Users?.station_id?.[0]?.station_name}</p>

                </div>
                <div className="col-md-6 mb-3">
                  <p><strong>Status:  &nbsp;</strong>{Users?.status}</p>
                  <p><strong>User Type: &nbsp;</strong>{Users?.userType}</p>
                  <p><strong>Wallet Amount:&nbsp; </strong>{Users?.wallet_amount}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <p><strong>Created Date:&nbsp; </strong>{Users?.createdAt}</p>
                  <p><strong>Updated Date: &nbsp;</strong>{Users?.updatedAt}</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default View;
